<template>
  <div class="devOps_producerSpaceDemand" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
        <el-input :style="iptStyle" placeholder="请输入"  @keyup.enter.native="formSearch('reset')" v-model="form.title" />
      </el-form-item>
      <el-form-item label="系统" prop="models_code" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.models_code" collapse-tags filterable
                   placeholder="请选择系统" clearable>
          <el-option v-for="(key, value) in workOrderSystem" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select :style="iptStyle" multiple filterable collapse-tags v-model="form.state"
                   placeholder="请选择状态">
          <el-option v-for="(value, key) in workOrderStatus" :key="value" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="级别">
        <el-select :style="iptStyle" multiple filterable collapse-tags v-model="form.level"
                   placeholder="请选择级别">
          <el-option v-for="(value, key) in workOrderLevel" :key="value" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="systemId" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.type" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in workOrderType" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目体系" prop="systemId" :label-width="formLabelWidth">
        <el-select size="mini" :style="iptStyle" v-model="form.project_system_id" collapse-tags filterable
                   placeholder="请选择项目体系" clearable>
          <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交人" prop="submitter_id" :label-width="formLabelWidth">
        <el-select size="mini" autocomplete="off"  v-model="form.submitter_id" clearable collapse-tags
                   filterable placeholder="请选择提交人">
          <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="受理人" prop="acceptor_id" :label-width="formLabelWidth">
        <el-select size="mini" autocomplete="off" v-model="form.acceptor_id" clearable collapse-tags
                   filterable placeholder="请选择受理人">
          <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_plt_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="起始日期"
            end-placeholder="截止日期" />
      </el-form-item>
      <el-form-item label="完成日期" label-width="125px">
        <el-date-picker
            v-model="form.serach_complete_time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="起始日期"
            end-placeholder="截止日期" />
      </el-form-item>
      <div>
        <el-form-item>
          <el-button v-if="allMenuList.btn_work_order_query" style="margin-left:32px;font-weight: bold;font-size: 12px;" type="primary"
                     @click="formSearch('reset','search')">查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="allMenuList.btn_work_order_clear" style="font-weight: bold;font-size: 12px;" type="primary"
                     @click="changeReset()">置空
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->

    <!-- #region 表格部分 -->
    <div style="height: 58vh;position: relative;">
      <el-table height="100%" :header-cell-style="getCellClass" row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData">
        <el-table-column  fixed="left"  prop="title" align="center" min-width="160" label="标题" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="table_text_click_new" @click="showDialogVisible('createWorkOrder', scope.row)">【{{scope.row.id}}】{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" align="center" width="80" label="类型" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="level" align="center" width="80" label="级别" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="level_style"  :style="{color:(scope.row.level=='紧急'?'#fff':''),background:(scope.row.level=='紧急'?'rgb(204, 51, 51)':'')}">{{scope.row.level}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" align="center" width="80" label="状态" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="module_code" label="系统" width="80" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="submitter_id" label="提交人" width="120" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.submitter_id.nameZh ? scope.row.submitter_id.nameZh : ''}} {{scope.row.submitter_id.nameEn ? '(' +scope.row.submitter_id.nameEn + ')' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="acceptor_id" label="受理人" width="120" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.acceptor_id.nameZh ? scope.row.acceptor_id.nameZh : ''}} {{scope.row.acceptor_id.nameEn ? '(' +scope.row.acceptor_id.nameEn + ')' : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="project_system_name" label="项目体系" width="80" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="create_time" align="center"  sortable="custom" width="100" label="提交日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="finish_date" align="center" sortable="custom" width="130" label="实际完成日期" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="consume_time" align="center" width="100" label="已耗时" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="evaluation" align="center" width="130" label="评分" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.evaluation" disabled></el-rate>
          </template>
        </el-table-column>
        <el-table-column prop="remind_count" fixed="right" align="center" width="80" label="催单次数" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="table_text_click_new" style="text-decoration:none;"  @click="showDialogVisible('reminderDetail', scope.row)">{{scope.row.remind_count}}次</span>
          </template>
        </el-table-column>
<!--        <el-table-column fixed="right" align="center" label="催单详情" width="80">-->
<!--          <template slot-scope="scope">-->
<!--                <el-button  @click="showDialogVisible('reminderDetail', scope.row)" type="text" size="small">详情-->
<!--                          </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <!-- #region 分页部分 -->
      <div class="block devOpsSpace_page">
        <span class="demonstration">当前页{{ currentPageLength || 0 }}条</span>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
                       layout="total, prev, pager, next, sizes" :total="count">
        </el-pagination>
      </div>
      <!-- #endregion -->
    </div>
    <!-- #endregion 表格部分 -->
    <!-- #region dialog 部分 -->
    <CreateWorkOrder  v-if="dialogVisible.createWorkOrder" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.createWorkOrder'
                      :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></CreateWorkOrder>
    <ReminderDetail v-if="dialogVisible.reminderDetail" :showDialogVisible="showDialogVisible" :dialogVisible='dialogVisible.reminderDetail'
                   :hideDialogVisible="hideDialogVisible" :formInfo="checkedInfo"></ReminderDetail>
    <!-- #endregion dialog 部分 -->
  </div>
</template>
<script>
import CreateWorkOrder from "@/views/tops/devOps/workOrder/components/createWorkOrder.vue";
import ReminderDetail from "@/views/tops/devOps/workOrder/components/reminderDetail.vue";
import {
  getDevOpsSpaceAllProjectApi, getDevOpsSpaceStageSelectmapApi, getDevOpsSpaceWorkOrderIndexApi,
} from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import { mapState, mapMutations } from 'vuex';
import {getDevOpsSpaceWorkOrderConfigApi} from "@/server/tops/base";
export default {
  components: {CreateWorkOrder,ReminderDetail },
  props: {
  },
  data() {
    return {
      // 表单搜索条件
      form: {
        serach_plt_time:'',
        serach_complete_time:'',
        search_approval_time: '',
        acceptor_id: '',
        state:[1 ,2, 3],
        systemId: '',
        projectName: '',
        title:'',
        type:'',
        project_system_id:'',

      },
      // 列表
      tableData: [],
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      // 弹出层部分
      dialogVisible: {
        createWorkOrder: false,
        reminderDetail:false,
      },
      // 选中信息
      checkedInfo: {},
      cacheTableData: [],
      count: 10, // 总计
      currentPage: 1, // 当前页
      currentPageLength: 10,
      pageSize: 10, // 每页多少个
      expands: [],
      preciseSwitch: false,
      users: {},
      loading:false,
      workOrderStatus:[],
      workOrderSystem:[],
      workOrderLevel:[],
      workOrderType:[],
    };
  },
  async created() {
    let pageSize = getStorage('pageSize', 'localStorage')
    pageSize && (this.pageSize = pageSize * 1);
    await this.$store.dispatch('getDevopsWorkOrderConfig')
    await this.$store.dispatch('getDevopsMenuList',{})
    await this.$store.dispatch('getDevopsSelect')
    await this.$store.dispatch('getDevopsSystem')
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    //项目状态
    await this.$store.dispatch('getDevopsStatusList',{type:''})
  },
  computed: {
    ...mapState(
        {
          // 进度条
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.NEWALLSYSTEM,
          allUserList: (state) => state.devOps.NEWALLUSERLIST,
          allStatusList: (state) => state.devOps.NEWALLSTATUSLIST,
          allMenuList: (state) => state.devOps.NEWALLMENULIST,
        }
    ),
  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    const { wid = '', ns = '' } = this.$route.query;

    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, user: username ? [username] : []};

    if(this.$store.state.devOps.userInfo.userId){
      let defauleOwnerId = this.$store.state.devOps.userInfo.userId;
      this.form.acceptor_id = defauleOwnerId.toString();
    }
    if (wid) {
      this.form.state = '';
      this.form.acceptor_id = '';
      this.form.submitter_id = '';
      this.form.title = wid;
    }
    if(ns == 13 ){
      this.form.state = [4];
    }
    this.$nextTick(async () => {
      await this.formSearch();
      await this.getWorkOrderConfig();
    })
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:14px;"
    },
    async getWorkOrderConfig() {
      await getDevOpsSpaceWorkOrderConfigApi({type: 'all'}).then((res) => {
        let system = [];
        let status = [];
        let level = [];
        let type = [];
        res.data.forEach((item, index) => {
          if (item.type === 1) {
            status[item.key]= item.value;
          }else if(item.type === 2){
            level[item.key]= item.value;
          }else if(item.type === 4){
            system[item.key]= item.value;
          }else if(item.type === 5){
            type[item.key]= item.value;
          }
        });
        this.workOrderStatus = status;
        this.workOrderSystem = system;
        this.workOrderLevel = level;
        this.workOrderType = type;
      })
    },
    // 表单搜索
    async formSearch(type,key) {
      this.form.planStartDate='';
      this.form.palnEndDate='';
      this.form.approvalStartDate='';
      this.form.approvalEndDate='';
      this.form.planCompleteStartDate='';
      this.form.planCompleteEndDate='';
      if(this.form.serach_plt_time){
        if(this.form.serach_plt_time[0]){
          this.form.planStartDate=this.form.serach_plt_time[0];
        }
        if(this.form.serach_plt_time[1]){
          this.form.palnEndDate=this.form.serach_plt_time[1];
        }
      }
      if(this.form.serach_complete_time){
        if(this.form.serach_complete_time[0]){
          this.form.planCompleteStartDate=this.form.serach_complete_time[0];
        }
        if(this.form.serach_complete_time[1]){
          this.form.planCompleteEndDate=this.form.serach_complete_time[1];
        }
      }

      if(this.form.search_approval_time){
        if(this.form.search_approval_time[0]){
          this.form.approvalStartDate=this.form.search_approval_time[0];
        }
        if(this.form.search_approval_time[1]){
          this.form.approvalEndDate=this.form.search_approval_time[1];
        }
      }

      if(type === 'reset'){
        this.pageNo = 1;
        this.currentPage = 1;
      }
      try {
        this.$refs.multipleTable.clearSort()
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        params.pageNo = this.currentPage
        params.pageSize = this.pageSize
        this.loading = true;
        const ret = await getDevOpsSpaceWorkOrderIndexApi(params);
        this.tableData = ret.data;
        this.cacheTableData = ret.data;
         this.currentPageLength = ret.data.length;
        this.count = ret.count;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading = false;
      }
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:6px 0;";
    },
    // 排序事件
    async sortChange(column) {
      const { prop, order } = column;
      if(prop === 'create_time') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.create_time) - Date.parse(a.create_time) : Date.parse(a.create_time) - Date.parse(b.create_time);
        })
      }
      if(prop === 'finish_date') {
        this.tableData.sort((a, b) => {
          // ascending 升序   descending 降序  null取消（升序）
          return order === 'descending' ? Date.parse(b.finish_date) - Date.parse(a.finish_date) : Date.parse(a.finish_date) - Date.parse(b.finish_date);
        })
      }
    },
    // 弹出模板
    async showDialogVisible(type, row,  back = '') {
      if (type === 'releaseing') {
        return;
      }
      await this.hideDialogVisible('', false)
      this.checkedInfo = row;
      this.dialogVisible[type] = true;
      this.back = back;
    },
    // 隐藏弹窗
    async hideDialogVisible(nextStep = '', search = true, ) {
      for (let key in this.dialogVisible) {
        this.dialogVisible[key] = false;
      }
      if (nextStep && (typeof(nextStep) === 'string')) {
        this.$nextTick(() => {
          this.checkedInfo && (this.dialogVisible[nextStep] = true);
        })
      } else {
        search && await this.formSearch()
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      setStorage('pageSize', val, 'localStorage')
      this.formSearch();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.formSearch();
    },
    changeReset(){
      this.form.title = '';
      this.form.models_code = '';
      this.form.state = '';
      this.form.level = '';
      this.form.submitter_id = '';
      this.form.acceptor_id = '';
      this.form.serach_plt_time = '';
      this.form.serach_complete_time = '';
      this.form.type = '';
      this.form.project_system_id = '';
    },
    fileExport() {
      let url = `${window.location.origin}/devops/space/reporter/new_export`;
      for (const key in this.form) {
        const val = this.form[key];
        url += `&${key}=${this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val}`;
      }
      url += `&pageNo=${this.currentPage}&pageSize=${this.pageSize}`;
      window.location.href = url;
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceDemand {

  .link_svg {
    position: absolute;
    left: -96px;
    top: 2px;
    transform: rotate(90deg);
    cursor: pointer;
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .dialog-footer .el-button {
    font-weight: bold;
    margin-left: 0;
    margin-right: 10px;
  }

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
  .priority_style {
    border-radius: 5px;
    text-align: center;
    width: fit-content;
    padding: 0 5px;
    margin: auto;
  }

  .el-dialog__header {
    font-weight: bold;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .devOpsSpace_page {
    // text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;

    .demonstration {
      font-size: 13px;
      color: #606266;
      line-height: 1;
      margin-top: 25px;
      margin-right: 10px;
    }
  }
}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.table_options_warp {
  position: absolute;
  z-index: 4;
  left: 20px;
  top: 22px;
  width: 20px;
  cursor: pointer;
}
.devOps_producerSpaceDemand .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
.level_style {
  border-radius: 5px;
  text-align: center;
  width: fit-content;
  padding: 0 5px;
  margin: auto;
}
</style>
